if (!window._babelPolyfill) {
  require('babel-polyfill');
}
require('./entry-header-ts');


//////////////////
// WEBPACK FOOTER
// ./src/entry-header.js
// module id = 528
// module chunks = 0